import { IBasicOrganization } from '../models/IOrganization';
import { UUID } from '../../types/uuid';

export type ParamChain<ParamType, ParamOut> = <ChainIn extends any[], ChainOut>(
  existingChain?: (...params: ChainIn) => ChainOut
) => (param: ParamType, ...params: ChainIn) => ChainOut & ParamOut;

const generateParamChainNode =
  <ParamType, ParamOut>(fun: (param: ParamType) => ParamOut): ParamChain<ParamType, ParamOut> =>
  <ChainIn extends any[], ChainOut>(chain?: (...params: ChainIn) => ChainOut) =>
  (param: ParamType, ...rest: ChainIn) => ({
    ...(chain?.(...rest) ?? ({} as never)),
    ...fun(param),
  });

export const orgIdParam = generateParamChainNode((organization: IBasicOrganization) => ({
  organization_id: organization.id,
}));

export const orgNameParam = generateParamChainNode((organization_name: string) => ({ organization_name }));

export const userIdParam = generateParamChainNode((user_id: UUID) => ({ user_id }));

export const licenseIdParam = generateParamChainNode((license_id: number) => ({ license_id }));

export const customerProductParam = generateParamChainNode((customer_product_id: number) => ({ customer_product_id }));

export const regionParam = generateParamChainNode((region: string) => ({ region }));

export const stackIdParam = generateParamChainNode((stack_id: string) => ({ stack_id }));

export const jobIdParam = generateParamChainNode((job_id: number) => ({ job_id }));

export const productIdParam = generateParamChainNode((product_id: number) => ({ product_id }));

export const versionParam = generateParamChainNode((version: string) => ({ version }));

export const oldRoleIdParam = generateParamChainNode((old_role_id: UUID) => ({ old_role_id }));

export const roleIdParam = generateParamChainNode((role_id: UUID) => ({ role_id }));

export const invitationIdParam = generateParamChainNode((invitation_id: UUID) => ({ invitation_id }));
